import { Flex } from 'onefaceui-react-components';
import styled from 'styled-components';

export const Container = styled(Flex)`
  flex: 1;

  .events-list {
    overflow-y: auto;
  }

  .oneface-date-picker button {
    padding-left: 0px !important;
    padding-right: 0px !important;
    height: auto !important;
  }
`;

export const Header = styled(Flex)`
  padding: 8px 14px;
  box-shadow: 0px 2px 6px #00000033;

  .date-filter {
    input {
      height: 30px !important;
      width: 100% !important;
      padding: 0 5px !important;
      padding-right: 28px !important;
    }
  }
`;

export const SearchInput = styled(Flex)`
  position: relative;

  .oneface-input {
    padding-right: 26px;
  }

  img {
    width: 34px;
    position: absolute;
    top: 4px;
    right: 2px;
  }
`;

export const Filters = styled(Flex)`
  margin-top: 4px;

  img {
    width: 26px;
  }
`;

export const ToggleButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  color: var(--grey-900);
  transition: all 0.2s;
  border-radius: 4px;

  height: auto !important;
  font-weight: 600 !important;
  padding: 2px 6px 2px 14px !important;

  &.active {
    color: var(--secondary-400);
  }

  &:hover {
    background-color: var(--grey-200);
  }

  &::after {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 100%;
    position: absolute;
    left: 2px;
  }

  &.normal::after {
    background-color: var(--grey-700);
  }

  &.urgent::after {
    background-color: var(--gold-400);
  }

  &.blocker::after {
    background-color: var(--red-400);
  }
`;

export const Event = styled.li`
  display: flex;
  flex: 1;
  max-height: 120px;
  min-height: 108px;
  border-bottom: solid var(--grey-300) 1px;

  .event-title {
    min-width: 0;
    flex: 1;

    > p {
      width: 80%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  .event-description {
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .status {
    width: 12px;

    &.normal {
      background-color: var(--grey-700);
    }

    &.urgent {
      background-color: var(--gold-400);
    }

    &.blocker {
      background-color: var(--red-400);
    }
  }

  .event-content {
    padding: 8px;
    flex: 1;
    min-width: 0;
  }

  .oneface-icon-button {
    height: auto !important;
    align-self: flex-start;
  }
`;
